import { createAction, createActionType } from '@ers/helpers/';


const prefix = 'Translations';
export const ActionTypes = {
    translationsFetched: createActionType('translationsFetched')(prefix)
};
export const translationsFetched = (code, translations) => createAction(ActionTypes.translationsFetched)({ payload: { code, translations } });